var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "banner-search" } }, [
    _c("div", { staticClass: "box" }, [
      _c("h2", { staticClass: "slogan" }, [_vm._v("查标讯,上采讯")]),
      _vm._v(" "),
      _c("p", { staticClass: "slogan-desc" }, [_vm._v("免费查看全国标讯信息")]),
      _vm._v(" "),
      _c("div", { staticClass: "search" }, [
        _c(
          "div",
          { staticClass: "search-wrap" },
          [
            _c("app-icon", { attrs: { type: "iconsousuo" } }),
            _vm._v(" "),
            _c("a-input-search", {
              attrs: {
                placeholder: "请输入您要查询标讯的关键字",
                value: _vm.searchText,
                enterButton: "搜索"
              },
              on: { change: _vm.onChange, search: _vm.onSearch }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "hot-links" },
          _vm._l(_vm.hotLinks, function(item, index) {
            return _c("span", { key: index, staticClass: "hot-item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.onClickSearchText(item)
                    }
                  }
                },
                [_vm._v(_vm._s(item))]
              )
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05ca1189", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ca1189","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/search.vue
// module id = a47R
// module chunks = 1